<script>
  export let videos = [
  ];
  let selectedVideo = null;
  const openModal = video => {
    const modal = document.createElement('div');
    modal.innerHTML = `
      <div class="modal">
        <span class="close">&times;</span>
        <div class="video-container">
          <iframe src="https://www.youtube.com/embed/${video.id}" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    const modalContent = modal.querySelector('.modal');
    const closeButton = modal.querySelector('.close');
    closeButton.onclick = () => {
      modalContent.style.display = 'none';
      document.body.removeChild(modal);
    };
    modalContent.style.display = 'block';

    // Set the iframe width and height to the maximum size of the screen
    const iframe = modal.querySelector('iframe');
    iframe.style.width = "90vw";
    iframe.style.height = "90vh";
  };
</script>
<style>
  .video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
  }
  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    border: none;
  }
</style>
<div class="sidenav">
  {#each videos as video}
    <button on:click={() => openModal(video)}>{video.title}</button>
  {/each}
</div>
